var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOUlEQVR42mMYBYMdMAafOwPCZGtmsJgAxiA2eZo180GYdEOAit2BVBoKVs/sAtMkABVsYqMpgwYAANxjGXaPVPmjAAAAAElFTkSuQmCC";
  export default img;